import styled from "@emotion/styled"
import { Box } from "@mui/material"
import Link from "next/link"
import { trackC2CClick, trackWhatsappClick } from "reusable/gtm"
import { Desktop, extractProperty, Mobile } from "ui"
import WhatsappIcon from "ui/icons/WhatsappIcon"

const StyledNotFound = styled.div`
    ${props => props.theme.breakpoints.up("md")} {
        border-radius: 28px;
        box-shadow:rgba(130, 136, 148, 0.4) 0px 4px 12px;
        margin-bottom: 40px;
        margin-top:60px;
    }

`
const StyledTitleHeader = styled.h3`
        background-color: #0050C9;
        margin:0;
        padding:16px;
        color: #FFFFFF;
        font-weight: 500;
        font-size: 24px;

        ${props => props.theme.breakpoints.up("md")} {
            border-radius: 28px 28px 0 0;
            padding:20px 16px;
            font-size: 36px;
        }
    `

const StyledContent = styled.div`
    padding:24px 40px;
`
const StyledSubtitleContent = styled(Box)`
    font-weight: 500;
    font-size:18px;
    line-height: 1.1;
   ${props => props.theme.breakpoints.up("md")} {
       font-size: 24px;
   }

    ${props => props.theme.breakpoints.down("sm")} {
        margin:0;
   }
`
const StyledPhoneContent = styled(Box)`
    display: flex;
    font-size: 18px;
    font-weight: 400;
    line-height: 1.5;
    align-items: center;
    gap: 16px;
    p{
        margin:0;
    }
`

const StyledPhoneContentMobile = styled(Box)`
    display: flex;
    flex-direction: column;
    font-size: 1px;
    line-height: 1.5;
    align-items: flex-start;
    gap: 16px;
    margin: 0;

    p{
        font-size: 14px;
        font-weight:400;
        margin-bottom: 0px;
    }
`

const StyledPhoneContentInner = styled.div`
b,h2,h3,h4{
    font-size:18px;
    padding-bottom: 12px;
}`

const StyledPhoneItem = styled(Box) <{ target: string }>`
    display: flex;
    align-items: center;
    gap: 8px;
    background-color: #0050c9;
    color: white;
    border-radius: 24px;
    height: 40px;
    width: 215px;
    display: flex;
    justify-content: center;
    border: none;
    color: white;
      font-weight: 500;
        text-decoration: none;
        font-size: 16px;

`
const StyledPhoneItemAndText = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;

    span{
        font-size: 14px;
        font-weight: 400;
    }

`

const StationNotFound = ({ data, type }: { data: any, type: "rent" | "sell" }) => {
    const block = extractProperty(data, "blocks")
    const infoBlock = block?.find((property: any) => property.blockType === "setationInfoBlock")
    const phoneMessageText = extractProperty(infoBlock, 'phoneMessageText')
    const whatsAppButton = extractProperty(infoBlock, "whatsAppButton")
    return (
        <StyledNotFound>
            <StyledTitleHeader>{type === "rent" ? "לא מוצאים מה שחיפשתם?" : "לשאלות ובירורים"}</StyledTitleHeader>
            <StyledContent>
                {type === "rent" &&
                    <StyledSubtitleContent>
                        הנציגים שלנו ישמחו לעזור לכם למצוא נכס להשכרה
                    </StyledSubtitleContent>
                }
                <Desktop>
                    <StyledPhoneContent>
                        <StyledPhoneContentInner dangerouslySetInnerHTML={{ __html: phoneMessageText }} />
                        {whatsAppButton && whatsAppButton[0] && (
                            <>
                                <span style={{ margin: '0 8px' }}>או</span>
                                <Link passHref legacyBehavior href={`https://wa.me/${whatsAppButton[0].url}`} >
                                    <StyledPhoneItem component="a" target={whatsAppButton[0].target} rel="noreferrer" onClick={() => {
                                        trackWhatsappClick("לא מוצאים מה שחיפשתם")
                                    }}>
                                        <WhatsappIcon />

                                        {whatsAppButton[0].name}<span style={{ marginRight: '8px' }}>←</span>

                                    </StyledPhoneItem>
                                </Link>
                            </>
                        )}
                    </StyledPhoneContent>
                </Desktop>
                <Mobile>
                    <StyledPhoneContentMobile>
                        <StyledPhoneContentInner dangerouslySetInnerHTML={{ __html: phoneMessageText }} />
                        <StyledPhoneItemAndText>
                            {whatsAppButton && whatsAppButton[0] && (
                                <>
                                    <span>או</span>
                                    <Link passHref legacyBehavior href={`https://wa.me/${whatsAppButton[0].url}`}>
                                        <StyledPhoneItem component="a" style={{ marginTop: 0 }} target="_blank" rel="noreferrer" onClick={() => {
                                            trackC2CClick("לא מוצאים מה שחיפשתם")
                                        }}>
                                            <WhatsappIcon />
                                            {whatsAppButton[0].name}<span style={{ marginRight: '8px' }}>←</span>
                                        </StyledPhoneItem>
                                    </Link>
                                </>
                            )}
                        </StyledPhoneItemAndText>
                    </StyledPhoneContentMobile>
                </Mobile>
            </StyledContent>
        </StyledNotFound>
    )
}

export default StationNotFound
